var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      attrs: { "data-title": "KPI告警监控" }
    },
    [
      _c(
        "div",
        { staticClass: "sms-content-main" },
        [
          _c("div", { staticClass: "filter-list" }, [
            _c("div", { staticClass: "filter-item middle-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          开始时间\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  { staticClass: "el-date-picker-wrapper" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "month",
                        placeholder: "选择月",
                        format: "yyyy年M月",
                        "value-format": "yyyy-MM-dd",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filter.startDate,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "startDate", $$v)
                        },
                        expression: "filter.startDate"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item middle-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          结束时间\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  { staticClass: "el-date-picker-wrapper" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "month",
                        placeholder: "选择月",
                        format: "yyyy年M月",
                        "value-format": "yyyy-MM-dd",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filter.endDate,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "endDate", $$v)
                        },
                        expression: "filter.endDate"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item small-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          指标类型\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  { staticClass: "el-select-wrapper kpi-type-select-wrapper" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: { change: _vm.onKpiTypeChange },
                        model: {
                          value: _vm.filter.kpiType.value,
                          callback: function($$v) {
                            _vm.$set(_vm.filter.kpiType, "value", $$v)
                          },
                          expression: "filter.kpiType.value"
                        }
                      },
                      _vm._l(_vm.filter.kpiType.options, function(item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { value: item.code, label: item.name }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item small-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          指标编号\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  { staticClass: "el-input-wrapper kpi-code-select-wrapper" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入内容", clearable: "" },
                      on: { change: _vm.buildTable },
                      model: {
                        value: _vm.filter.kpiCode.value,
                        callback: function($$v) {
                          _vm.$set(_vm.filter.kpiCode, "value", $$v)
                        },
                        expression: "filter.kpiCode.value"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item middle-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          指标名称\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  { staticClass: "el-input-wrapper" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入内容", clearable: "" },
                      on: { change: _vm.buildTable },
                      model: {
                        value: _vm.filter.kpiName.value,
                        callback: function($$v) {
                          _vm.$set(_vm.filter.kpiName, "value", $$v)
                        },
                        expression: "filter.kpiName.value"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item middle-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          机型\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  { staticClass: "el-select-wrapper" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: { change: _vm.onAirTypeChange },
                        model: {
                          value: _vm.filter.airType.value,
                          callback: function($$v) {
                            _vm.$set(_vm.filter.airType, "value", $$v)
                          },
                          expression: "filter.airType.value"
                        }
                      },
                      _vm._l(_vm.filter.airType.options, function(item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { value: item.code, label: item.name }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-list" }, [
            _c("div", { staticClass: "filter-item middle-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          责任部门\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  { staticClass: "el-select-wrapper" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: { change: _vm.onRespDeptChange },
                        model: {
                          value: _vm.filter.respDept.value,
                          callback: function($$v) {
                            _vm.$set(_vm.filter.respDept, "value", $$v)
                          },
                          expression: "filter.respDept.value"
                        }
                      },
                      _vm._l(_vm.filter.respDept.options, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { value: item.id, label: item.name }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item middle-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          预警等级\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  { staticClass: "el-select-wrapper" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: { change: _vm.onWarningLevelChange },
                        model: {
                          value: _vm.filter.warningLevel.value,
                          callback: function($$v) {
                            _vm.$set(_vm.filter.warningLevel, "value", $$v)
                          },
                          expression: "filter.warningLevel.value"
                        }
                      },
                      _vm._l(_vm.filter.warningLevel.options, function(item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { value: item.code, label: item.name }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item small-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          处理状态\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "el-select-wrapper process-status-select-wrapper"
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: { change: _vm.onProcessStatusChange },
                        model: {
                          value: _vm.filter.processStatus.value,
                          callback: function($$v) {
                            _vm.$set(_vm.filter.processStatus, "value", $$v)
                          },
                          expression: "filter.processStatus.value"
                        }
                      },
                      _vm._l(_vm.filter.processStatus.options, function(item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { value: item.code, label: item.name }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item process-desc-filter-item" }, [
              _c("div", { staticClass: "item-label" }, [
                _vm._v("\n          处理说明\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-component" }, [
                _c(
                  "div",
                  {
                    staticClass: "el-input-wrapper process-desc-input-wrapper"
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入内容", clearable: "" },
                      on: { change: _vm.buildTable },
                      model: {
                        value: _vm.filter.processDesc.value,
                        callback: function($$v) {
                          _vm.$set(_vm.filter.processDesc, "value", $$v)
                        },
                        expression: "filter.processDesc.value"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-item middle-filter-item btn-filter-item" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.buildTable }
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: { click: _vm.onFilterResetClick }
                  },
                  [_vm._v("重置")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { ref: "table", staticClass: "el-table-wrapper" },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.standardDangerData,
                    "header-cell-class-name": "custom-table-header-cell",
                    "cell-class-name": "cell-class",
                    "max-height": "500"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "No.",
                      prop: "index",
                      width: "50",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "kpiTypeText",
                      label: "指标类型",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "kpiCode",
                      label: "指标编号",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "middle" },
                                on: {
                                  click: function($event) {
                                    return _vm.onKpiCodeClick(scope.row)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.kpiCode) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "dateText", label: "月份", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "kpiName",
                      label: "指标名称",
                      align: "center",
                      width: "130"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "kpiExplain",
                      label: "指标说明",
                      align: "center",
                      width: "130"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "airTypeText",
                      label: "机型",
                      align: "center",
                      width: "70"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "actualValue",
                      label: "实际值",
                      align: "center",
                      width: "90"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "actual-value-box",
                                class: _vm.$util.getRiskLevelBgColor(
                                  scope.row.color
                                )
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.actualValue) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "warningTime",
                      label: "告警时间",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "processStatusText",
                      label: "处理状态",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "process-status-box",
                                class: {
                                  "risk-level-color-red":
                                    scope.row.processStatus === "UNTREATED"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.processStatusText) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.processStatus === "UNTREATED" &&
                            (scope.row.color === "YELLOW" ||
                              scope.row.color === "RED")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      disabled: !_vm.permission.process
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onProcessClick(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("处理\n            ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.processStatus === "UNTREATED" &&
                            (scope.row.color === "YELLOW" ||
                              scope.row.color === "RED")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      disabled: !_vm.permission.ignore
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onIgnoreClick(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("忽略\n            ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.processStatus === "IGNORE"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      disabled: !_vm.permission.ignore
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onCancelIgnoreClick(
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("取消忽略\n            ")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "processDesc",
                      label: "处理说明",
                      align: "center",
                      width: "100",
                      "show-overflow-tooltip": true
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._l(scope.row.riaActivitiesInfoList, function(
                              info
                            ) {
                              return scope.row.processStatus === "PROCESSED"
                                ? _c(
                                    "el-link",
                                    {
                                      key: info.id,
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                        target: "_blank",
                                        href: _vm.$util.buildSmsActivityDetailUrl(
                                          info.id
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(info.activityNo) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            scope.row.processStatus !== "PROCESSED"
                              ? _c(
                                  "div",
                                  { staticClass: "overflow-ellipsis" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.processDesc) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "processorName",
                      label: "处理人",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "processTime",
                      label: "处理时间",
                      align: "center"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-wrapper" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next",
                  total: _vm.page.total,
                  "current-page": _vm.page.num,
                  "page-size": _vm.page.size
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.page, "num", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.page, "num", $event)
                  },
                  "update:pageSize": function($event) {
                    return _vm.$set(_vm.page, "size", $event)
                  },
                  "update:page-size": function($event) {
                    return _vm.$set(_vm.page, "size", $event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "KPI图表",
                visible: _vm.kpiChart.visible,
                width: "60%"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.kpiChart, "visible", $event)
                },
                close: _vm.onKpiChartDialogClose
              }
            },
            [
              _vm.kpiChart.kpiCode
                ? _c("KpiChart", {
                    ref: "kpiChartRef",
                    attrs: {
                      kpiCode: _vm.kpiChart.kpiCode,
                      year: Number(_vm.kpiChart.year),
                      "default-air-type": _vm.kpiChart.airType
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                "custom-class": "ria-activity-dialog",
                title: "新建风险评估单",
                width: "650px",
                visible: _vm.riaActivity.visible,
                "destroy-on-close": true,
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.riaActivity, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { ref: "riaActivityFormBox", staticClass: "el-form-wrapper" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "riaActivityForm",
                      attrs: {
                        "label-position": "right",
                        "label-width": "80px",
                        model: _vm.riaActivity.values,
                        rules: _vm.riaActivity.form.rules,
                        size: "mini"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属机构", prop: "company" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择",
                                    disabled: _vm.companyOptions.length === 1
                                  },
                                  on: { change: _vm.onCompanyChange },
                                  model: {
                                    value: _vm.riaActivity.values.company,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.riaActivity.values,
                                        "company",
                                        $$v
                                      )
                                    },
                                    expression: "riaActivity.values.company"
                                  }
                                },
                                _vm._l(_vm.companyOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: item.shortName
                                        ? item.shortName
                                        : item.name,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型", prop: "type" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                { attrs: { disabled: "", value: "" } },
                                [
                                  _c("el-option", {
                                    attrs: { label: "风险评估单", value: "" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-divider"),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "编号", prop: "serialNumber" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.riaActivity.values.serialNumber,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.riaActivity.values,
                                      "serialNumber",
                                      $$v
                                    )
                                  },
                                  expression: "riaActivity.values.serialNumber"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题", prop: "summary" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.riaActivity.values.summary,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.riaActivity.values,
                                      "summary",
                                      $$v
                                    )
                                  },
                                  expression: "riaActivity.values.summary"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "详细描述", prop: "description" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.riaActivity.values.description,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.riaActivity.values,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "riaActivity.values.description"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "责任部门", prop: "respDept" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { multiple: "" },
                                  model: {
                                    value: _vm.riaActivity.values.respDepts,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.riaActivity.values,
                                        "respDepts",
                                        $$v
                                      )
                                    },
                                    expression: "riaActivity.values.respDepts"
                                  }
                                },
                                _vm._l(_vm.filter.respDept.options, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { value: item.id, label: item.name }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "结案时限", prop: "processDeadline" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "el-date-picker-wrapper" },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  format: "yyyy年M月d日",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.riaActivity.values.processDeadline,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.riaActivity.values,
                                      "processDeadline",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "riaActivity.values.processDeadline"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "来源", prop: "source" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                { attrs: { disabled: "", value: "" } },
                                [
                                  _c("el-option", {
                                    attrs: { label: "核心风险", value: "" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "附件", prop: "attachment" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "string",
                                "on-preview": _vm.handlePreview,
                                "on-remove": _vm.handleRemove,
                                "before-remove": _vm.beforeRemove,
                                multiple: "",
                                limit: 3,
                                "http-request": _vm.onUploadfiles,
                                "on-exceed": _vm.handleExceed,
                                "file-list": _vm.fileList
                              }
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "small", type: "primary" } },
                                [_vm._v("点击上传")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            { on: { click: _vm.useChartAttachment } },
                            [_vm._v("使用系统已有图表作为附件")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticClass: "btn-container" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onSubmitClick }
                            },
                            [_vm._v("确认")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            { on: { click: _vm.onCancelClick } },
                            [_vm._v("取消")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                "custom-class": "ria-activity-dialog",
                title: _vm.supActivity.values.title,
                width: "650px",
                visible: _vm.supActivity.visible,
                "destroy-on-close": true,
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.supActivity, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  ref: "supActivityFormBox",
                  staticClass: "el-form-wrapper",
                  staticStyle: { "margin-left": "30px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "supActivityForm",
                      attrs: {
                        "label-position": "right",
                        "label-width": "100px",
                        model: _vm.supActivity.values,
                        rules: _vm.supActivity.form.rules,
                        size: "mini"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属机构", prop: "company" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择",
                                    disabled: _vm.companyOptions.length === 1
                                  },
                                  on: { change: _vm.onCompanyChange },
                                  model: {
                                    value: _vm.supActivity.values.company,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.supActivity.values,
                                        "company",
                                        $$v
                                      )
                                    },
                                    expression: "supActivity.values.company"
                                  }
                                },
                                _vm._l(_vm.companyOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: item.shortName
                                        ? item.shortName
                                        : item.name,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型", prop: "type" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  on: { change: _vm.onTypeChange },
                                  model: {
                                    value: _vm.supActivity.values.type,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.supActivity.values,
                                        "type",
                                        $$v
                                      )
                                    },
                                    expression: "supActivity.values.type"
                                  }
                                },
                                _vm._l(this.typeOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      value: item.code,
                                      label: item.name
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类别", prop: "categoryType" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.supActivity.values.categoryType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.supActivity.values,
                                        "categoryType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "supActivity.values.categoryType"
                                  }
                                },
                                _vm._l(this.categoryOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      value: item.code,
                                      label: item.name
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-divider"),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题", prop: "summary" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.supActivity.values.summary,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.supActivity.values,
                                      "summary",
                                      $$v
                                    )
                                  },
                                  expression: "supActivity.values.summary"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "工作来源", prop: "workSource" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.supActivity.values.workSource,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.supActivity.values,
                                        "workSource",
                                        $$v
                                      )
                                    },
                                    expression: "supActivity.values.workSource"
                                  }
                                },
                                _vm._l(
                                  _vm.supActivity.values.workSourceOptions,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.srcId,
                                      attrs: {
                                        value: item.value,
                                        label: item.name
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "被检查单位", prop: "checkOrg" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c("el-tree", {
                                ref: "checkOrgTree",
                                attrs: {
                                  data: _vm.supActivity.form.checkOrgTree.data,
                                  "node-key": "id",
                                  props:
                                    _vm.supActivity.form.checkOrgTree
                                      .defaultProps,
                                  "show-checkbox": "",
                                  "check-strictly": true
                                },
                                on: {
                                  "check-change":
                                    _vm.supActivity.form.checkOrgTree
                                      .handleCheckChange
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "详细描述", prop: "description" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.supActivity.values.description,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.supActivity.values,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "supActivity.values.description"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "检查年度", prop: "checkYear" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.supActivity.values.checkYear,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.supActivity.values,
                                        "checkYear",
                                        $$v
                                      )
                                    },
                                    expression: "supActivity.values.checkYear"
                                  }
                                },
                                _vm._l(
                                  _vm.supActivity.values.checkYearOptions,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.srcId,
                                      attrs: {
                                        value: item.value,
                                        label: item.name
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "检查月份", prop: "checkMonth" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { multiple: "" },
                                  model: {
                                    value: _vm.supActivity.values.checkMonth,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.supActivity.values,
                                        "checkMonth",
                                        $$v
                                      )
                                    },
                                    expression: "supActivity.values.checkMonth"
                                  }
                                },
                                _vm._l(
                                  _vm.supActivity.values.checkMonthOptions,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.srcId,
                                      attrs: {
                                        value: item.value,
                                        label: item.name
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "检查次数", prop: "checkTimes" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.supActivity.values.checkTimes,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.supActivity.values,
                                      "checkTimes",
                                      $$v
                                    )
                                  },
                                  expression: "supActivity.values.checkTimes"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "检查城市", prop: "checkCity" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-select-wrapper" },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.supActivity.values.checkCity,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.supActivity.values,
                                        "checkCity",
                                        $$v
                                      )
                                    },
                                    expression: "supActivity.values.checkCity"
                                  }
                                },
                                _vm._l(
                                  _vm.supActivity.values.checkCityOptions,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.srcId,
                                      attrs: {
                                        value: item.srcId,
                                        label: item.name
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "检查地点", prop: "checkPlace" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.supActivity.values.checkPlace,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.supActivity.values,
                                      "checkPlace",
                                      $$v
                                    )
                                  },
                                  expression: "supActivity.values.checkPlace"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "标准工时", prop: "standardWorkHour" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.supActivity.values.standardWorkHour,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.supActivity.values,
                                      "standardWorkHour",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "supActivity.values.standardWorkHour"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c(
                            "div",
                            { staticClass: "el-input-wrapper" },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.supActivity.values.remark,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.supActivity.values,
                                      "remark",
                                      $$v
                                    )
                                  },
                                  expression: "supActivity.values.remark"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticClass: "btn-container" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onSubmitClick }
                            },
                            [_vm._v("确认")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            { on: { click: _vm.onCancelClick } },
                            [_vm._v("取消")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f85e8ba8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f85e8ba8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/KpiMonitoring.vue
// module id = null
// module chunks = 